import React, { useState, useRef } from 'react'
import AnimatedPage from '../../components/AnimatedPage';
import CustomModal from '../../components/Modal';
import { BackButton } from '../../components/BackButton';
import Img_Icon from '../../assets/images/Group_Icon_digisign.png'
import Layout_1 from '../../assets/images/Layer_Detail_digisign2.png'
import Button_Frame from '../../assets/images/Frame_Button.DS.png'
import VideoFile from '../../assets/videos/Huong dan dang ky chu ky so bgr.mp4'
import { motion } from 'framer-motion';
import styled, { keyframes } from 'styled-components';
import Pause_Icon from '../../assets/images/pause-button.png';
import Play_Icon from '../../assets/images/play-button.png';

const DetailDigisign2 = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [showPlayIcon, setShowPlayIcon] = useState(false);
    const videoRef = useRef(null);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setIsPlaying(false);
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    };

    const togglePlayPause = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                videoRef.current.play();
                setIsPlaying(true);
            } else {
                videoRef.current.pause();
                setIsPlaying(false);
            }

            setShowPlayIcon(true);
            setTimeout(() => {
                setShowPlayIcon(false);
            }, 1000);
        }
    };

    const handleVideoPlay = () => {
        setIsPlaying(true);
    };

    const handleVideoPause = () => {
        setIsPlaying(false);
    };
    return (
        <AnimatedPage animationType="fade">
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                }}
            >
                <BackButton />
                <img
                    src={Img_Icon}
                    alt=""
                    style={{
                        width: `calc(977 / 4096 * 100vw)`,
                        height: `calc(453 /  2160 * 100vh)`,
                        objectFit: 'contain',
                        marginTop: `calc(50 / 2160 * 100vh)`,

                    }}
                />
                <motion.img
                    src={Layout_1}
                    alt=""
                    style={{
                        marginTop: `calc(90 / 2160 * 100vh)`,
                        width: `calc(3390 / 4096 * 100vw)`,
                        height: `calc(1026 /  2160 * 100vh)`,
                        objectFit: 'contain',
                    }}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.1, duration: 0.5, ease: 'easeOut' }}
                />
                <motion.div
                    style={{
                        marginTop: `calc(60 / 2160 * 100vh)`,
                        width: `calc(1389 / 4096 * 100vw)`,
                        height: `calc(212 /  2160 * 100vh)`,
                        position: 'relative',
                    }}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.1, duration: 0.5, ease: 'easeOut' }}
                >
                    <Button >
                        <TextButton>ỨNG DỤNG CHỮ KÝ SỐ</TextButton>
                    </Button>
                    <img onClick={openModal} src={Button_Frame} alt="" width={'100%'} height={'100%'} style={{ position: 'absolute', top: 0, left: 0 }} />
                </motion.div>

                {/* Modal với video */}
                <CustomModal isOpen={isModalOpen} onClose={closeModal}>
                    <VideoContainer onClick={togglePlayPause}>
                        <StyledVideo
                            ref={videoRef}
                            src={VideoFile}
                            autoPlay
                            loop
                            muted={false}
                            onPlay={handleVideoPlay}
                            onPause={handleVideoPause}
                        />
                        {showPlayIcon && (
                            <PlayIcon
                                as={motion.div}
                                initial={{ opacity: 0, scale: 0.5 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.5 }}
                                transition={{ duration: 0.2 }}
                            >
                                {isPlaying ? <img src={Pause_Icon} alt="Pause" width={'60px'} height={'60px'} /> : <img src={Play_Icon} alt="Play" width={'60px'} height={'60px'} />}
                            </PlayIcon>
                        )}
                    </VideoContainer>
                </CustomModal>
            </div>
        </AnimatedPage>
    )
}

export default DetailDigisign2;
const rotate = keyframes`
    from { transform: translate(-50%, -50%) scale(1.4) rotate(0turn); }
    to { transform: translate(-50%, -50%) scale(1.4) rotate(1turn); }
`;

const clickAnimation = keyframes`
    0% { transform: translate(-50%, -50%) scale(1); }
    50% { transform: translate(-50%, -50%) scale(1.1); }
    100% { transform: translate(-50%, -50%) scale(1); }
`;
const Button = styled(motion.div)`
    --offset: 1px;
    width:100%;
    height: 100%;
    position: absolute;
    top:50%;
    left:50%;
    border-radius: 1px;
    max-width: 100%;
transform: translate(-50%, -50%);
    background-color: #055200;
  overflow: hidden;
    transition: transform 0.1s ease;
    animation: ${props => props.isClicked ? clickAnimation : 'none'} 0.3s ease;
     display: flex;
    justify-content: center;
    align-items: center;

    &::before {
        content: '';
        background: conic-gradient(transparent 270deg, ${props => props.rgb || 'rgb(255 255 255)'}, transparent);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        aspect-ratio: 1 / 1;
        width: 100%;
        animation: ${rotate} 2s linear infinite;
        pointer-events: none;
    }

    &::after {
        content: '';
        background: inherit;
        border-radius: inherit;
        position: absolute;
        inset: var(--offset);
        height: calc(100% - 2 * var(--offset));
        width: calc(100% - 2 * var(--offset));
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        pointer-events: none;
    }
    &:hover {
        cursor: pointer;
    }
`;

const TextButton = styled.p`
font-size: ${props => `calc( ${props.size || 90} / 4096 * 100vw)`};
font-weight: 700;
color: white;
text-align: center;
    z-index: 10;
    margin-left: calc(20 / 2160 * 100vh);
        margin-right: calc(20 / 2160 * 100vh);

`;

const VideoContainer = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledVideo = styled.video`
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 10px;
`;

const PlayIcon = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 48px;
    color: white;
    padding: 20px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    pointer-events: none;
    animation: fadeInOut 1s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;

    @keyframes fadeInOut {
        0% { opacity: 0; }
        50% { opacity: 1; }
        100% { opacity: 0; }
    }
`;